var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":("modal-alert-rule-branch-" + (_vm.branchData.branchId)),"title":this.$t('menu.settings.alertsNewsletters.ruleBranch', {
      branchDataName: ("" + (_vm.branchData.name)),
    }),"size":"xl","ok-title":("" + (this.$t('menu.settings.alertsNewsletters.save'))),"cancel-title":("" + (this.$t('menu.settings.alertsNewsletters.cancel')))},on:{"ok":_vm.saveBranchRule}},[_c('new-rule-branch',{attrs:{"branchData":_vm.branchData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d7f7ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/modal-alert-rule-branch/index.vue
// module id = null
// module chunks = 